"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplaceCarFooterBannerWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@athena-portal/core");
var services_1 = require("@falcon/services");
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var moment = require("moment");
var ReplaceCarFooterBannerWidget = /** @class */ (function (_super) {
    __extends(ReplaceCarFooterBannerWidget, _super);
    function ReplaceCarFooterBannerWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            carToReplace: null
        };
        return _this;
    }
    ReplaceCarFooterBannerWidget.prototype.componentDidMount = function () {
        var _this = this;
        this.customerPortalService.getPolicy(this.props.engine.getInteraction().agreementNumber).subscribe(function (policy) {
            _this.setState({
                carToReplace: policy.insuredVehicles[0]
            });
        });
    };
    ReplaceCarFooterBannerWidget.prototype.render = function () {
        var vehicleWording;
        if (this.state.carToReplace) {
            vehicleWording = this.state.carToReplace.make + " "
                + this.state.carToReplace.model + " (" + this.state.carToReplace.registrationNumber + ")";
        }
        else {
            vehicleWording = "your already covered vehicle";
        }
        var date = moment(this.props.engine.getInteraction().headerInfo.startDate)
            .format("D MMM YYYY") + " 23:59";
        return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", { className: "price-transparency-widget _panel rounded bg-white-blue m-0 p-0 d-table-cell", children: [(0, jsx_runtime_1.jsx)("img", { className: "mt-4 mb-2 mx-3 h-30 float-left", src: "/img/alert-grey-blue.svg", alt: "Grey alert icon" }), (0, jsx_runtime_1.jsx)("div", { className: "line-height-15 m-3", children: (0, jsx_runtime_1.jsxs)("label", { children: ["The cover for ", vehicleWording, " WILL END on ", date] }) })] }) }));
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], ReplaceCarFooterBannerWidget.prototype, "customerPortalService", void 0);
    return ReplaceCarFooterBannerWidget;
}(plugin_journey_1.WidgetBase));
exports.ReplaceCarFooterBannerWidget = ReplaceCarFooterBannerWidget;
//# sourceMappingURL=ReplaceCarFooterBannerWidget.js.map